import { MultiToggle } from '../../../../../core/components';
import { getSelectedValueFromSimulatorConfig } from '../../../utils/get-selected-value-from-simulator-config';
import simulatorConfig, {
  heartCondition as heartConditionConstants,
} from '../../../constants/simulator-config-constants';
import { ExperimentConfiguration } from '../../../models';
import { ModalSubSection } from '../modal-sub-section';

type HeartConditionSectionProps = {
  config: ExperimentConfiguration[];
  updatePatientSettings: (action: string, value: string, configurationName: string) => void;
};

export const HeartConditionSection = ({ config, updatePatientSettings }: HeartConditionSectionProps) => {
  const heartConditionSelectedValue = getSelectedValueFromSimulatorConfig(config, simulatorConfig.HEART_CONDITION);

  const onHeartConditionSelectHandler = (heartCondition: string) => {
    updatePatientSettings('true', heartCondition, simulatorConfig.HEART_CONDITION);
  };

  return (
    <ModalSubSection title="Heart condition">
      <MultiToggle
        items={[
          { id: heartConditionConstants.HEALTHY, label: 'Healthy' },
          { id: heartConditionConstants.MYOCARDIAL_INFARCTION, label: 'Myocardial Infarction' },
        ]}
        onSelect={(heartConditionValue) => onHeartConditionSelectHandler(heartConditionValue)}
        selectedItemKey={heartConditionSelectedValue}
      />
    </ModalSubSection>
  );
};
